export default "__VITE_ASSET__CCSTWpCL__"